module.exports = __webpack_public_path__ + "img/card4.f3c9fb12.png";